import { connect } from "react-redux"
import { insightAreaFingerprintRemoveConcept } from "../../../../actions/insight-area-actions"
import { convertFPToFlow } from "../../../../reducers/entities/topic-fingerprint-entity-reducer"

import InsightAreaFingerprintWidget from "../InsightAreaFingerprintWidget"

const mapStateToProps = ({ entities, presentation }) => ({
    fingerprintFlow: presentation.insightAreas.fingerprintPreview
        ? convertFPToFlow(presentation.insightAreas.fingerprintPreview)
        : entities.topicFingerprints[presentation.insightAreas.activeId] &&
          entities.topicFingerprints[presentation.insightAreas.activeId].flow,
    isFetching: presentation.insightAreas.isFetchingFingerprintPreview,
    mappings: presentation.insightAreas.workingModel.mappings.reduce(
        (flatMappings, { positive }) =>
            flatMappings.concat(positive.map(({ name }) => name)),
        []
    ),
})

const mapDispatchToProps = (dispatch) => ({
    onRemoveItemClick: (key) =>
        dispatch(insightAreaFingerprintRemoveConcept(key)),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InsightAreaFingerprintWidget)
